function callbackFunc(entries, observer) {
    entries.forEach(entry => {
        if (entry.target.children.length > 1) {
            if (
                (entry.target.children[0].classList.contains('box-left') ||
                    entry.target.children[1].classList.contains('box-right')) &&
                entry.isIntersecting) {
                entry.target.children[0].classList.add('slide-in');
                entry.target.children[1].classList.add('slide-in');
            } else {
                entry.target.children[0].classList.remove('slide-in');
                entry.target.children[1].classList.remove('slide-in');
            }
        }
        if (entry.target.children.length > 0) {
            if (entry.target.classList.contains('box-bottom') && entry.isIntersecting) {
                entry.target.children[0].classList.add('slide-up');
            } else {
                entry.target.children[0].classList.remove('slide-up');
            }
        }
    });
}

let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
};

let observer = new IntersectionObserver(callbackFunc, options);
var boxDisplays = document.getElementsByClassName('box-top');
for (var i = 0; i < boxDisplays.length; i++) {
    observer.observe(boxDisplays[i]);
}

let options2 = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
};

let observer2 = new IntersectionObserver(callbackFunc, options2);
var boxBottom = document.getElementsByClassName('box-bottom');
for (var i = 0; i < boxBottom.length; i++) {
    observer2.observe(boxBottom[i]);
}

// Slider
document.addEventListener('DOMContentLoaded', function () {

    var wisliderdesktop =  document.getElementById('wisliderdesktop');
    if (typeof(wisliderdesktop) != 'undefined' && wisliderdesktop != null)
    {
        new Splide('#wisliderdesktop', {
            arrows: false,
            autoplay: true,
            type: 'slide',
            autoWidth: true,
            pagination: false,
            focus  : 'center'
        }).mount();
    }

    var wisliderdesktop =  document.getElementById('wislidermobile');
    if (typeof(wisliderdesktop) != 'undefined' && wisliderdesktop != null)
    {
        new Splide('#wislidermobile', {
            arrows: false,
            autoplay: true,
            type: 'slide',
            autoWidth: true,
            focus  : 'center'
        }).mount();
    }

    var sectionslider =  document.getElementsByClassName('section-slider');
    if (sectionslider.length > 0)
    {
        new Splide('.section-slider', {
            arrows: true,
            type: 'slide',
            width: '500px',
            fixedHeight: 500,
            fixedWidth: 500,
            pagination: false,
            focus: 'center',
            perPage: 1,
            breakpoints: {
                989: {
                    width: '100%',
                    gap: 17,
                    trimSpace: true,
                    arrows: false,
                    pagination: true
                },
                580: {
                    width: '100%',
                    fixedHeight: 300,
                    fixedWidth: 300,
                    gap: 17,
                    pagination: true,
                    trimSpace: false
                }
            }
        }).mount();
    }

    var galleryslider =  document.getElementsByClassName('gallery-slider');
    if (galleryslider.length > 0)
    {
        new Splide('.gallery-slider', {
            type: 'slide',
            width: '100%',
            fixedHeight: 300,
            fixedWidth: 300,
            gap: 17,
            pagination: false,
            perPage: 1,
            focus: 'center',
            trimSpace: true,
            arrows: false,
            cover: true,
            rewind: true,
            breakpoints: {
                989: {
                },
                580: {
                    trimSpace: false,
                    fixedHeight: 300,
                    fixedWidth: 300,
                    pagination: true
                }
            }
        }).mount();
    }

    var subscribeslider =  document.getElementsByClassName('subscribe-slider');
    if (subscribeslider.length > 0)
    {
        new Splide('.subscribe-slider', {
            autoplay: true,
            type: 'slide',
            width: '100%',
            fixedHeight: 460,
            gap: 0,
            pagination: true,
            perPage: 1,
            focus: 'center',
            trimSpace: true,
            arrows: false,
            cover: true,
            rewind: true,
            breakpoints: {
                989: {
                },
                749: {
                    trimSpace: false,
                    fixedHeight: 375,
                    fixedWidth: 0,
                    pagination: true
                }
            }
        }).mount();
    }

    // var reviewsslider =  document.getElementsByClassName('reviews-slider');
    // if (reviewsslider.length > 0)
    // {
    //     new Splide('.reviews-slider', {
    //         type: 'slide',
    //         width: '100%',
    //         fixedHeight: 444,
    //         fixedWidth: 577,
    //         gap: 17,
    //         pagination: false,
    //         focus: 'center',
    //         perPage: 1,
    //         trimSpace: true,
    //         arrows: false,
    //         breakpoints: {
    //             989: {
    //             },
    //             580: {
    //                 trimSpace: false,
    //                 fixedHeight: 456,
    //                 fixedWidth: 306,
    //                 pagination: true
    //             }
    //         }
    //     }).mount();
    // }
});
